import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const CustomTextField = withStyles({
  root: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    "& label.Mui-focused": {
      color: "#3D71FF",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      "& fieldset": {
        borderColor: "#DEE7EE",
      },
      "&:hover fieldset": {
        borderColor: "#DEE7EE",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3D71FF",
      },
    },
  },
})(TextField);

const ForgottenPasswordForm = (props) => {
  return (
    <div>
      <form method="POST" action="/password_resets">
        <CustomTextField
          autoFocus
          label="Email Address"
          margin="normal"
          variant="outlined"
          id="emai-forgot"
          name="email"
          fullWidth
          required
        />
        <div className="register__form__footnote">
          Having trouble? Feel free to live chat with us or email us at
          support@340besp.com
        </div>
        <div className="register__form__actions">
          <a href="/register">
            <div className="btn btn--outline btn--white">
              Don't have an account?
            </div>
          </a>
          <button
            className="btn"
            style={{ flexGrow: 1, marginLeft: 30 }}
            type="submit"
          >
            Reset Password
          </button>
        </div>
      </form>
    </div>
  );
};

export default ForgottenPasswordForm;
